
import { Job } from "@/models/job";
import Vue from "vue";
import AppCreateUblArchiveModalWrapper from "./CreatePdfArchiveModalWrapper.vue";

export default Vue.extend({
	props: {
		job: Object as ()=>Job
	},
	methods: {
		close(){
			this.$emit("close");
		}
	},
	components: {
		AppCreateUblArchiveModalWrapper
	},
	i18nEx: {
		componentPrefix: "components.pdf-archive"
	}
});
